var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { t } from 'i18next';
import { v4 as uuidv4 } from 'uuid';
import '../../styles/widgets/popup/spinnerManipulativePopup.scss';
import ButtonComponent from '../../components/ButtonComponent';
import CheckBox from '../../components/CheckBox';
import InputBox from '../../components/InputBox';
import CustomScrollbar from '../../components/CustomScrollbar';
import MathEditor from '../../components/MathEditor';
import FooterActionsButtons from './FooterActionsButtons';
import SpinnerManipulative from '../SpinnerManipulative';
import { DataContext } from '../../player/DataContext';
import globalStore from '../../store';
import { saveState } from '../../helper/stateManagerHelper';
var MAX_SECTIONS = 12;
var MIN_SECTIONS = 1;
var MIN_VISIBLE_SLOTS = 4;
var MAX_TEXT_LENGTH = 10;
var MAX_PERCENT = 100;
var colorBtns = [
    {
        id: 'color1',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_0_N.svg',
            hover: './assets/images/manipulative/spinner/color_0_NH.svg',
            disable: './assets/images/manipulative/spinner/color_0_N.svg',
            active: './assets/images/manipulative/spinner/color_0_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_0_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_0_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_0_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_0_N.svg',
        },
        color: '#ffffff',
        colorName: 'text.colorWhite',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_0.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_0.svg',
        },
    },
    {
        id: 'color1',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_1_N.svg',
            hover: './assets/images/manipulative/spinner/color_1_NH.svg',
            disable: './assets/images/manipulative/spinner/color_1_N.svg',
            active: './assets/images/manipulative/spinner/color_1_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_1_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_1_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_1_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_1_N.svg',
        },
        color: '#FFCB87',
        colorName: 'text.colorLightOrange',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_1.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_1.svg',
        },
    },
    {
        id: 'color2',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_2_N.svg',
            hover: './assets/images/manipulative/spinner/color_2_NH.svg',
            disable: './assets/images/manipulative/spinner/color_2_N.svg',
            active: './assets/images/manipulative/spinner/color_2_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_2_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_2_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_2_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_2_N.svg',
        },
        color: '#FFA894',
        colorName: 'text.colorPeach',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_2.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_2.svg',
        },
    },
    {
        id: 'color3',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_3_N.svg',
            hover: './assets/images/manipulative/spinner/color_3_NH.svg',
            disable: './assets/images/manipulative/spinner/color_3_N.svg',
            active: './assets/images/manipulative/spinner/color_3_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_3_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_3_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_3_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_3_N.svg',
        },
        color: '#F97F89',
        colorName: 'text.colorCoral',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_3.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_3.svg',
        },
    },
    {
        id: 'color4',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_4_N.svg',
            hover: './assets/images/manipulative/spinner/color_4_NH.svg',
            disable: './assets/images/manipulative/spinner/color_4_N.svg',
            active: './assets/images/manipulative/spinner/color_4_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_4_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_4_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_4_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_4_N.svg',
        },
        color: '#F9B6C5',
        colorName: 'text.colorPink',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_4.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_4.svg',
        },
    },
    {
        id: 'color5',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_5_N.svg',
            hover: './assets/images/manipulative/spinner/color_5_NH.svg',
            disable: './assets/images/manipulative/spinner/color_5_N.svg',
            active: './assets/images/manipulative/spinner/color_5_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_5_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_5_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_5_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_5_N.svg',
        },
        color: '#C193B8',
        colorName: 'text.colorPurple',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_5.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_5.svg',
        },
    },
    {
        id: 'color6',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_6_N.svg',
            hover: './assets/images/manipulative/spinner/color_6_NH.svg',
            disable: './assets/images/manipulative/spinner/color_6_N.svg',
            active: './assets/images/manipulative/spinner/color_6_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_6_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_6_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_6_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_6_N.svg',
        },
        color: '#A8B7E0',
        colorName: 'text.colorLightBlue',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_6.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_6.svg',
        },
    },
    {
        id: 'color7',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_7_N.svg',
            hover: './assets/images/manipulative/spinner/color_7_NH.svg',
            disable: './assets/images/manipulative/spinner/color_7_N.svg',
            active: './assets/images/manipulative/spinner/color_7_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_7_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_7_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_7_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_7_N.svg',
        },
        color: '#88D2F8',
        colorName: 'text.colorSkyBlue',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_7.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_7.svg',
        },
    },
    {
        id: 'color8',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_8_N.svg',
            hover: './assets/images/manipulative/spinner/color_8_NH.svg',
            disable: './assets/images/manipulative/spinner/color_8_N.svg',
            active: './assets/images/manipulative/spinner/color_8_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_8_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_8_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_8_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_8_N.svg',
        },
        color: '#81E8E5',
        colorName: 'text.colorTeal',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_8.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_8.svg',
        },
    },
    {
        id: 'color9',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_9_N.svg',
            hover: './assets/images/manipulative/spinner/color_9_NH.svg',
            disable: './assets/images/manipulative/spinner/color_9_N.svg',
            active: './assets/images/manipulative/spinner/color_9_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_9_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_9_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_9_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_9_N.svg',
        },
        color: '#B7E5A6',
        colorName: 'text.colorLightGreen',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_9.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_9.svg',
        },
    },
    {
        id: 'color10',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_10_N.svg',
            hover: './assets/images/manipulative/spinner/color_10_NH.svg',
            disable: './assets/images/manipulative/spinner/color_10_N.svg',
            active: './assets/images/manipulative/spinner/color_10_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_10_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_10_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_10_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_10_N.svg',
        },
        color: '#EAEFAC',
        colorName: 'text.colorLime',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_10.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_10.svg',
        },
    },
    {
        id: 'color11',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_11_N.svg',
            hover: './assets/images/manipulative/spinner/color_11_NH.svg',
            disable: './assets/images/manipulative/spinner/color_11_N.svg',
            active: './assets/images/manipulative/spinner/color_11_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_11_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_11_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_11_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_11_N.svg',
        },
        color: '#FFF490',
        colorName: 'text.colorYellow',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_11.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_11.svg',
        },
    },
    {
        id: 'color12',
        type: 'btn',
        imgSrc: {
            normal: './assets/images/manipulative/spinner/color_12_N.svg',
            hover: './assets/images/manipulative/spinner/color_12_NH.svg',
            disable: './assets/images/manipulative/spinner/color_12_N.svg',
            active: './assets/images/manipulative/spinner/color_12_NH.svg',
            activeHover: './assets/images/manipulative/spinner/color_12_NH.svg',
            normaldark: './assets/images/manipulative/spinner/color_12_N.svg',
            hoverdark: './assets/images/manipulative/spinner/color_12_H.svg',
            disabledark: './assets/images/manipulative/spinner/color_12_N.svg',
        },
        color: '#F9E380',
        colorName: 'text.colorGold',
        displayBtnSrc: {
            normal: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            hover: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            disable: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            active: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            activeHover: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            normaldark: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            hoverdark: './assets/images/manipulative/spinner/colorN_Display_12.svg',
            disabledark: './assets/images/manipulative/spinner/colorN_Display_12.svg',
        },
    },
];
/** Default section factory */
var defaultSection = function (colorIdx) {
    if (colorIdx === void 0) { colorIdx = 0; }
    return ({
        text: [{ type: 'text', value: '' }],
        color: colorBtns[colorIdx % colorBtns.length].color,
        percent: 0,
    });
};
/** Build equal-percent sections of given count */
var buildEqualSections = function (count) {
    var pct = Math.round((100 / count) * 100) / 100;
    return Array.from({ length: count }, function (_, i) { return (__assign(__assign({}, defaultSection(i)), { percent: i === count - 1 ? 100 - pct * (count - 1) : pct })); });
};
var SpinnerManipulativePopup = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var existingData = props.data;
    var _l = useContext(DataContext), setManipulative = _l.setManipulative, manipulative = _l.manipulative, setManiplulatorComponentVisible = _l.setManiplulatorComponentVisible, selectedManipulativeId = _l.selectedManipulativeId, setSelectedManipulativeId = _l.setSelectedManipulativeId, setActiveManipulator = _l.setActiveManipulator, setSelectedTool = _l.setSelectedTool, getPositionForNewItem = _l.getPositionForNewItem;
    var _m = globalStore.useStoreState(function (s) { return s.jsonDataStore; }), bottomToolConfig = _m.bottomToolConfig, btnConfig = _m.btnConfig;
    var language = globalStore.useStoreState(function (s) { return s.playerStore; }).language;
    var DividerLine = function (_a) {
        var _b = _a.last, last = _b === void 0 ? false : _b, style = _a.style;
        return (_jsx("div", { "aria-hidden": "true", className: "dividerLine", style: __assign(__assign({}, (last ? { marginRight: 0 } : {})), style) }));
    };
    /*  ---- initial state from existing data or defaults ---- */
    var initialSections = (existingData === null || existingData === void 0 ? void 0 : existingData.sections) && existingData.sections.length > 0
        ? existingData.sections.map(function (s) { return ({
            text: typeof s.text === 'string'
                ? [{ type: 'text', value: s.text }]
                : s.text || [{ type: 'text', value: '' }],
            color: s.color,
            percent: s.percent,
        }); })
        : buildEqualSections(1);
    var _o = useState({
        id: (_a = existingData === null || existingData === void 0 ? void 0 : existingData.id) !== null && _a !== void 0 ? _a : '',
        type: 'spinner',
        center: (_b = existingData === null || existingData === void 0 ? void 0 : existingData.center) !== null && _b !== void 0 ? _b : { x: 0, y: 0 },
        radius: (_c = existingData === null || existingData === void 0 ? void 0 : existingData.radius) !== null && _c !== void 0 ? _c : 160,
        scale: 1, // always preview at scale 1 in popup regardless of canvas scale
        rotation: (_d = existingData === null || existingData === void 0 ? void 0 : existingData.rotation) !== null && _d !== void 0 ? _d : 30,
        sectionStartAngle: (_e = existingData === null || existingData === void 0 ? void 0 : existingData.sectionStartAngle) !== null && _e !== void 0 ? _e : -90,
        arrowOnly: (_f = existingData === null || existingData === void 0 ? void 0 : existingData.arrowOnly) !== null && _f !== void 0 ? _f : false,
        lock: (_g = existingData === null || existingData === void 0 ? void 0 : existingData.lock) !== null && _g !== void 0 ? _g : { positioning: false, editing: false },
        sections: initialSections,
    }), spinnerData = _o[0], setSpinnerData = _o[1];
    var spinnerDataRef = useRef(spinnerData);
    useEffect(function () {
        spinnerDataRef.current = spinnerData;
    }, [spinnerData]);
    var sections = (_h = spinnerData.sections) !== null && _h !== void 0 ? _h : [];
    var sectionCount = sections.length;
    /* ---- color palette state ---- */
    var _p = useState(-1), colorPaletteOpen = _p[0], setColorPaletteOpen = _p[1]; // index of section, -1 = closed
    var _q = useState(false), showPallete = _q[0], setShowPallete = _q[1];
    var colorButtonRefs = useRef([]);
    var colorBtnRefs = useRef([]);
    var palleteRef = useRef(null);
    /* ---- math editor refs ---- */
    var mathEditorRefs = useRef([]);
    var _r = useState(-1), activeMathInput = _r[0], setActiveMathInput = _r[1];
    var _s = useState(''), popupAnnounceText = _s[0], setPopupAnnounceText = _s[1];
    var _t = useState({}), percentRevision = _t[0], setPercentRevision = _t[1];
    var setCtxSelectedTool = useContext(DataContext).setSelectedTool;
    /* ---- extra scroll padding so tooltips aren't clipped ---- */
    var scrollbarHolderRef = useRef(null);
    var _u = useState(0), extraScrollPadding = _u[0], setExtraScrollPadding = _u[1];
    // ref so the effect can read the previously-applied padding without it being a dependency
    var extraScrollPaddingRef = useRef(0);
    var TOOLTIP_HEIGHT_PX = 60;
    useLayoutEffect(function () {
        if (!scrollbarHolderRef.current)
            return;
        var scrollContent = scrollbarHolderRef.current.querySelector('.customScrollbarContent');
        if (!scrollContent)
            return;
        var holders = scrollbarHolderRef.current.querySelectorAll('.sectionHolder');
        if (!holders.length)
            return;
        var lastHolder = holders[holders.length - 1];
        // Convert lastHolder's bottom to a position within the scroll content
        // (works regardless of current scroll offset)
        var lastHolderBottom = lastHolder.getBoundingClientRect().bottom -
            scrollContent.getBoundingClientRect().top +
            scrollContent.scrollTop;
        // Subtract previously-applied padding to get the natural scrollHeight
        var naturalScrollHeight = scrollContent.scrollHeight - extraScrollPaddingRef.current;
        var spaceBelow = naturalScrollHeight - lastHolderBottom;
        var newPadding = Math.max(0, TOOLTIP_HEIGHT_PX - spaceBelow);
        if (newPadding !== extraScrollPaddingRef.current) {
            extraScrollPaddingRef.current = newPadding;
            setExtraScrollPadding(newPadding);
        }
    }, [sectionCount, spinnerData.arrowOnly]);
    /* ---- validation ---- */
    var totalPercent = sections.reduce(function (sum, s) { return sum + s.percent; }, 0);
    var isPercentValid = Math.abs(totalPercent - 100) < 0.1;
    var disableDone = !isPercentValid || (spinnerData.arrowOnly === false && sectionCount < 1);
    /* ================================================================== */
    /*  Section management                                                */
    /* ================================================================== */
    var recalcPercent = function (count) { return +(100 / count); };
    var updateSectionCount = function (newCount) {
        var _a;
        if (newCount < MIN_SECTIONS || newCount > MAX_SECTIONS)
            return;
        var equalPercent = recalcPercent(newCount);
        var updated = __spreadArray([], ((_a = spinnerData.sections) !== null && _a !== void 0 ? _a : []), true);
        if (newCount > updated.length) {
            for (var i = updated.length; i < newCount; i++) {
                updated.push({
                    text: [{ type: 'text', value: '' }],
                    color: colorBtns[0].color,
                    percent: equalPercent,
                });
            }
        }
        if (newCount < updated.length) {
            updated = updated.slice(0, newCount);
        }
        updated = updated.map(function (sec) { return (__assign(__assign({}, sec), { percent: equalPercent })); });
        setSpinnerData(function (prev) { return (__assign(__assign({}, prev), { sections: updated })); });
        setPopupAnnounceText("Spinner now has ".concat(newCount, " section").concat(newCount !== 1 ? 's' : ''));
    };
    /* ================================================================== */
    /*  Text change handler                                               */
    /* ================================================================== */
    var handleTextChange = function (content, _type, index) {
        var idx = Number(index);
        var sanitize = function (val) { return (val ? val.replace(/<br\s*\/?>/gi, '') : ''); };
        setSpinnerData(function (prev) {
            var _a;
            var newSections = __spreadArray([], ((_a = prev.sections) !== null && _a !== void 0 ? _a : []), true);
            if (typeof content === 'string') {
                newSections[idx] = __assign(__assign({}, newSections[idx]), { text: [{ type: 'text', value: sanitize(content) }] });
            }
            else {
                newSections[idx] = __assign(__assign({}, newSections[idx]), { text: content.map(function (item) { return (__assign(__assign({}, item), { value: sanitize(item.value) })); }) });
            }
            return __assign(__assign({}, prev), { sections: newSections });
        });
    };
    /* ================================================================== */
    /*  Color change handler                                              */
    /* ================================================================== */
    var handleColorChange = function (sectionIdx, color) {
        setSpinnerData(function (prev) {
            var _a;
            var newSections = __spreadArray([], ((_a = prev.sections) !== null && _a !== void 0 ? _a : []), true);
            newSections[sectionIdx] = __assign(__assign({}, newSections[sectionIdx]), { color: colorBtns[color].color });
            return __assign(__assign({}, prev), { sections: newSections });
        });
        setColorPaletteOpen(-1);
        setShowPallete(false);
        setPopupAnnounceText("Section ".concat(sectionIdx + 1, " color changed"));
        // Restore focus to the color button that opened the palette
        setTimeout(function () {
            var _a;
            (_a = colorBtnRefs.current[sectionIdx]) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
    };
    /* ================================================================== */
    /*  Percent change handler                                            */
    /* ================================================================== */
    /**
     * Commit a percent value on blur/Enter — clamp, redistribute, and update state.
     * Called via InputBox's onChange('blur') callback, NOT on every keystroke.
     */
    var commitPercentChange = function (idx, val) {
        var _a;
        var numVal = Number(val.replace(',', '.'));
        if (isNaN(numVal))
            return;
        var currentSections = __spreadArray([], ((_a = spinnerData.sections) !== null && _a !== void 0 ? _a : []), true);
        var minPct = 1;
        var maxForEdited = MAX_PERCENT - (currentSections.length - 1) * minPct;
        var newValue = Math.min(Math.max(numVal, minPct), maxForEdited);
        var updated = currentSections.map(function (sec, i) {
            return i === idx ? __assign(__assign({}, sec), { percent: newValue }) : sec;
        });
        if (currentSections.length > 1) {
            var total = updated.reduce(function (sum, sec) { return sum + sec.percent; }, 0);
            if (total > MAX_PERCENT) {
                var excess = +(total - MAX_PERCENT).toFixed(1);
                for (var i = updated.length - 1; i >= 0 && excess > 0; i--) {
                    if (i === idx)
                        continue;
                    var reduce = Math.min(excess, +(updated[i].percent - minPct).toFixed(1));
                    updated[i] = __assign(__assign({}, updated[i]), { percent: +(updated[i].percent - reduce).toFixed(1) });
                    excess = +(excess - reduce).toFixed(1);
                }
            }
            else if (total < MAX_PERCENT) {
                var deficit = +(MAX_PERCENT - total).toFixed(1);
                var addTo = idx === updated.length - 1 ? updated.length - 2 : updated.length - 1;
                if (addTo >= 0) {
                    updated[addTo] = __assign(__assign({}, updated[addTo]), { percent: +(updated[addTo].percent + deficit).toFixed(1) });
                }
            }
        }
        setSpinnerData(function (prev) { return (__assign(__assign({}, prev), { sections: updated })); });
        // Bump revision to force InputBox remount when clamped value equals current value
        setPercentRevision(function (r) {
            var _a;
            var _b;
            return (__assign(__assign({}, r), (_a = {}, _a[idx] = ((_b = r[idx]) !== null && _b !== void 0 ? _b : 0) + 1, _a)));
        });
    };
    /* ================================================================== */
    /*  Math text button handler                                          */
    /* ================================================================== */
    var addMathText = function (index) {
        setCtxSelectedTool(["spinnerMathText_dummyForPopup_".concat(index)]);
        setTimeout(function () {
            var _a;
            (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.insertMath();
        }, 10);
    };
    /* ================================================================== */
    /*  Done handler                                                      */
    /* ================================================================== */
    var handleDone = function () {
        // Deferred save: let MathEditor blur callbacks fire first
        setSelectedTool([]);
        setTimeout(function () {
            var _a, _b, _c;
            var currentData = spinnerDataRef.current;
            var finalSections = (_a = currentData.sections) !== null && _a !== void 0 ? _a : [];
            var oldItem = selectedManipulativeId !== ''
                ? manipulative.find(function (m) { return m.data.id === selectedManipulativeId && m.data.type === 'spinner'; })
                : undefined;
            if (oldItem) {
                // Update existing spinner
                var newData = __assign(__assign({}, oldItem.data), { sections: finalSections, sectionStartAngle: currentData.sectionStartAngle, arrowOnly: currentData.arrowOnly });
                var updatedItem_1 = __assign(__assign({}, oldItem), { data: newData });
                // Save .data (not full manipulativeInterface) so undo/redo spread works correctly
                saveState({
                    type: selectedManipulativeId,
                    id: selectedManipulativeId.split('_')[1],
                    propertyName: 'completeData',
                    old: JSON.stringify(oldItem.data),
                    new: JSON.stringify(newData),
                });
                setManipulative(function (prev) {
                    return prev.map(function (item) { return (item.data.id === selectedManipulativeId ? updatedItem_1 : item); });
                });
                // Auto-select edited spinner so focus moves to it
                setSelectedTool([selectedManipulativeId]);
            }
            else {
                // Create new spinner
                var _d = getPositionForNewItem(), x = _d.x, y = _d.y;
                var newId = "spinner_".concat(uuidv4().replace(/-/g, ''));
                var newItem_1 = {
                    type: 'spinner',
                    widgetId: "spinner:".concat(uuidv4().replace(/-/g, '')),
                    data: {
                        id: newId,
                        type: 'spinner',
                        center: { x: x, y: y },
                        radius: (_b = currentData.radius) !== null && _b !== void 0 ? _b : 160,
                        scale: 1,
                        rotation: 30,
                        sectionStartAngle: -90,
                        arrowOnly: (_c = currentData.arrowOnly) !== null && _c !== void 0 ? _c : false,
                        sections: finalSections,
                        lock: { positioning: false, editing: false },
                        isPreset: false,
                    },
                };
                saveState({
                    type: newId,
                    id: newId.split('_')[1],
                    propertyName: 'create',
                    old: JSON.stringify(newItem_1),
                });
                setManipulative(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newItem_1], false); });
                setSelectedTool([newId]);
            }
            setSelectedManipulativeId('');
            setManiplulatorComponentVisible(false);
            setActiveManipulator('');
        }, 150);
    };
    /* ================================================================== */
    /*  Cancel handler                                                    */
    /* ================================================================== */
    var handleCancel = function () {
        setSelectedManipulativeId('');
        setManiplulatorComponentVisible(false);
        setActiveManipulator('');
    };
    /* ================================================================== */
    /*  Color palette positioning                                         */
    /* ================================================================== */
    var getColorPalettePosition = function (idx) {
        var btn = colorBtnRefs.current[idx];
        if (!btn)
            return { top: 0, left: 0 };
        var rect = btn.getBoundingClientRect();
        return { top: rect.bottom + 4, left: rect.left };
    };
    useEffect(function () {
        var _a, _b;
        var handleClickOutside = function (e) {
            var target = e.target;
            if (showPallete && palleteRef.current && !palleteRef.current.contains(target)) {
                var idx_1 = colorPaletteOpen;
                setShowPallete(false);
                setColorPaletteOpen(-1);
                setTimeout(function () {
                    var _a;
                    (_a = colorBtnRefs.current[idx_1]) === null || _a === void 0 ? void 0 : _a.focus();
                }, 0);
            }
        };
        if (showPallete && colorPaletteOpen >= 0) {
            var currentColor_1 = (_b = (_a = spinnerData.sections) === null || _a === void 0 ? void 0 : _a[colorPaletteOpen]) === null || _b === void 0 ? void 0 : _b.color;
            var matchIdx = colorBtns.findIndex(function (cb) { return cb.color === currentColor_1; });
            var focusIdx_1 = matchIdx >= 0 ? matchIdx : 0;
            setTimeout(function () {
                var _a;
                (_a = colorButtonRefs.current[focusIdx_1]) === null || _a === void 0 ? void 0 : _a.focus();
            }, 500);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPallete]);
    /* ---- iPad: scroll focused input into view above on-screen keyboard ---- */
    useEffect(function () {
        var holder = scrollbarHolderRef.current;
        if (!holder)
            return;
        var onFocus = function (e) {
            var _a;
            var target = e.target;
            if (!((_a = target === null || target === void 0 ? void 0 : target.closest) === null || _a === void 0 ? void 0 : _a.call(target, '.contentInputHolder')))
                return;
            setTimeout(function () {
                window.scrollTo({
                    top: target.getBoundingClientRect().top - window.innerHeight / 3,
                    behavior: 'smooth',
                });
            }, 300);
        };
        holder.addEventListener('focusin', onFocus);
        return function () { return holder.removeEventListener('focusin', onFocus); };
    }, []);
    /* ================================================================== */
    /*  JSX                                                               */
    /* ================================================================== */
    return (_jsx("div", { className: "spinnerManipulativePopup", "data-mfdeselect": "true", children: _jsxs("div", { className: "scrollbarHolder", ref: scrollbarHolderRef, children: [_jsx("div", { className: "spinnerPreviewArea", children: _jsx(SpinnerManipulative, { id: "spinnerPreview", data: spinnerData, setData: setSpinnerData, showOperator: !spinnerData.arrowOnly && sectionCount > 1, calledFrom: "popup" }) }), _jsxs("div", { className: "operationContainer", children: [_jsx("div", { className: "warningText ".concat(!spinnerData.arrowOnly ? 'visible' : ''), "aria-hidden": spinnerData.arrowOnly ? true : undefined, children: !isPercentValid && !spinnerData.arrowOnly ? (_jsxs("span", { children: [_jsx("span", { "aria-hidden": "true", children: "* " }), _jsx("span", { role: "alert", children: t('text.spinerWarningMessage') })] })) : (t('text.spinnerInstruction')) }), _jsxs(CustomScrollbar, { direction: "vertical", tabIndex: -1, children: [_jsxs("div", { className: "spinnerControlsRow", children: [_jsxs("div", { className: "buildSpinnerGroup", role: "group", "aria-label": t('text.buildSpinner'), "aria-disabled": spinnerData.arrowOnly || undefined, children: [_jsx("span", { className: "buildSpinnerLabel  ".concat(spinnerData.arrowOnly ? 'disableSections' : ''), style: !spinnerData.arrowOnly ? { opacity: 1 } : { opacity: 0.3 }, "aria-hidden": "true", children: t('text.buildSpinner') }), _jsx(DividerLine, { style: !spinnerData.arrowOnly ? { opacity: 1 } : { opacity: 0.3 } }), _jsxs("div", { className: "incDecGroup", children: [_jsx(ButtonComponent, { imgSrc: btnConfig.minus.imgSrc, defaultCSS: "incDecBtn", normalCSS: "incDecBtn", clickHandler: function () { return updateSectionCount(sectionCount - 1); }, disabled: sectionCount <= MIN_SECTIONS || spinnerData.arrowOnly, tabIndex: sectionCount <= MIN_SECTIONS || spinnerData.arrowOnly ? -1 : undefined, ariaLabel: t('text.decreaseSectionCount'), clickActive: false }), _jsxs("div", { className: "sectionCountDisplay  ".concat(spinnerData.arrowOnly ? 'disableSections' : ''), style: !spinnerData.arrowOnly ? { opacity: 1 } : { opacity: 0.3 }, role: "status", "aria-live": spinnerData.arrowOnly ? 'off' : 'polite', "aria-disabled": spinnerData.arrowOnly || undefined, "aria-hidden": spinnerData.arrowOnly || undefined, children: [_jsx("span", { "aria-hidden": "true", children: sectionCount }), _jsx("span", { className: "srOnly", children: t('text.totalSections', { count: ((_j = spinnerData.sections) === null || _j === void 0 ? void 0 : _j.length) || 1 }) })] }), _jsx(ButtonComponent, { imgSrc: btnConfig.plus.imgSrc, defaultCSS: "incDecBtn", normalCSS: "incDecBtn", clickHandler: function () { return updateSectionCount(sectionCount + 1); }, disabled: sectionCount >= MAX_SECTIONS || spinnerData.arrowOnly, tabIndex: sectionCount >= MAX_SECTIONS || spinnerData.arrowOnly ? -1 : undefined, ariaLabel: t('text.increaseSectionCount'), clickActive: false }), _jsx(DividerLine, {})] })] }), _jsxs("div", { className: "modeGroup", role: "group", "aria-label": t('text.mode'), children: [_jsx("span", { className: "modeLabel", "aria-hidden": "true", children: t('text.mode') }), _jsx(DividerLine, {}), _jsx(CheckBox, { checked: (_k = spinnerData.arrowOnly) !== null && _k !== void 0 ? _k : false, label: t('text.arrowOnly'), ariaLabel: t('text.toggleArrowOnly'), onClick: function () {
                                                        setSpinnerData(function (prev) { return (__assign(__assign({}, prev), { arrowOnly: !prev.arrowOnly })); });
                                                    } }), _jsx(DividerLine, { last: true })] })] }), _jsx("div", { className: "seperatorLine paddingRight" }), _jsx("div", { className: "sectionConfigGrid ".concat(spinnerData.arrowOnly ? 'disableSections' : ''), children: Array.from({ length: Math.max(sectionCount, MIN_VISIBLE_SLOTS) }, function (_, index) {
                                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                                        var sec = sections[index];
                                        var isActive = index < sectionCount && !spinnerData.arrowOnly;
                                        return (_jsxs("fieldset", { className: "sectionHolder ".concat(!isActive ? 'disableSections' : ''), "aria-disabled": !isActive, "aria-hidden": !isActive ? true : undefined, inert: !isActive ? true : undefined, children: [_jsxs("legend", { className: "sectionLabel", style: isActive
                                                        ? { opacity: 1, pointerEvents: 'all' }
                                                        : { opacity: 0.3, pointerEvents: 'none' }, children: [t('text.section'), " ", index + 1] }), _jsxs("div", { className: "contentInputHolder", style: isActive
                                                        ? { opacity: 1, pointerEvents: 'all' }
                                                        : { opacity: 0.3, pointerEvents: 'none' }, children: [_jsx(MathEditor, { data: {
                                                                type: 'data',
                                                                data: {
                                                                    text: (sec === null || sec === void 0 ? void 0 : sec.text) || [{ type: 'text', value: '' }],
                                                                    color: '#293273',
                                                                    alignment: 'center',
                                                                    height: 52,
                                                                    lineWidth: 170,
                                                                },
                                                            }, color: "#293273", className: "mathJaxWrapper", placeHolder: '  ', isTextUpdate: false, index: index, idPreffix: "spinnerMathText_dummyForPopup", cb: handleTextChange, keypadButtons: bottomToolConfig.mathKeypad, bottomBtns: bottomToolConfig.mathKeypadBottom, disableTransform: true, setActiveMathText: setActiveMathInput, viewonly: !isActive, throwChangeOnBlur: true, maxCharacters: MAX_TEXT_LENGTH, ref: function (el) {
                                                                if (el)
                                                                    mathEditorRefs.current[index] = el;
                                                            }, isManipulative: true, blockNewLine: true }), !isActive && (_jsx("div", { style: {
                                                                width: '100%',
                                                                height: '100%',
                                                                position: 'absolute',
                                                                top: '0',
                                                            } }))] }), _jsxs("div", { className: "bottomContainer", children: [_jsx(ButtonComponent, { type: "imageType5", imgSrc: __assign({}, btnConfig.mathtext.imgSrc), disabled: !isActive ||
                                                                ((_b = (_a = mathEditorRefs === null || mathEditorRefs === void 0 ? void 0 : mathEditorRefs.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.mathFieldInstancesCount()) === 2, tabIndex: !isActive ||
                                                                ((_d = (_c = mathEditorRefs === null || mathEditorRefs === void 0 ? void 0 : mathEditorRefs.current) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.mathFieldInstancesCount()) === 2
                                                                ? -1
                                                                : undefined, defaultCSS: "mathTextBtn", clickActive: true, isActive: activeMathInput === index, controlActiveFromOutside: true, clickHandler: function () { return addMathText(index); }, showToolTip: true, direction: index === 0 && ((_f = (_e = spinnerData.sections) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 5
                                                                ? 'topRight'
                                                                : 'top', isParentRelative: true, title: t('text.openMathKeypad'), ariaLabel: t('text.openMathKeypad'), ariaHaspopup: "true", ariaExpanded: activeMathInput === index }), _jsx(ButtonComponent, { type: "imageType5", imgSrc: ((_g = colorBtns.find(function (cb) { return cb.color === (sec === null || sec === void 0 ? void 0 : sec.color); })) !== null && _g !== void 0 ? _g : colorBtns[0])
                                                                .displayBtnSrc, defaultCSS: "mathTextBtn", controlActiveFromOutside: true, isActive: colorPaletteOpen === index, clickActive: true, clickHandler: function () {
                                                                setColorPaletteOpen(colorPaletteOpen === index ? -1 : index);
                                                                setShowPallete(true);
                                                            }, disabled: !isActive || spinnerData.arrowOnly, tabIndex: !isActive || spinnerData.arrowOnly ? -1 : undefined, title: t("text.colours"), showToolTip: true, direction: index === 0 && ((_j = (_h = spinnerData.sections) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : 0) > 5 ? 'top' : 'top', isParentRelative: true, ariaLabel: "".concat(t('text.section'), " ").concat(index + 1, " ").concat(t('text.colours'), ": ").concat(t((_l = (_k = colorBtns.find(function (cb) { return cb.color === (sec === null || sec === void 0 ? void 0 : sec.color); })) === null || _k === void 0 ? void 0 : _k.colorName) !== null && _l !== void 0 ? _l : 'text.colorWhite')), ariaExpanded: colorPaletteOpen === index, ariaHaspopup: "true", reference: function (el) {
                                                                colorBtnRefs.current[index] = el;
                                                            } }), _jsx(InputBox, { id: "id_".concat(index), defaultCSS: "inputCSS", normalCSS: "percentInputCSS", type: "text", inputMode: "numeric", placeholder: "00", maxLength: 5, value: Number(((_m = sec === null || sec === void 0 ? void 0 : sec.percent) === null || _m === void 0 ? void 0 : _m.toFixed(1)) || 0).toLocaleString(language === 'es' ? 'es' : 'en'), onChange: function (_id, eventType, val) {
                                                                if (eventType === 'blur' || eventType === 'keyUp') {
                                                                    commitPercentChange(index, val);
                                                                }
                                                            }, disabled: !isActive, ariaLabel: t('text.sectionPercentLabel', { index: index + 1 }), invalidKeys: ['ArrowUp', 'ArrowDown'] }, "pct_".concat(index)), _jsx("span", { className: "percentSign", "aria-hidden": "true", style: isActive
                                                                ? { opacity: 1, pointerEvents: 'all' }
                                                                : { opacity: 0.3, pointerEvents: 'none' }, children: "%" })] })] }, index));
                                    }) })] })] }), _jsx("div", { className: "colorPaletteOverlay", onClick: function () { return setColorPaletteOpen(-1); }, "aria-hidden": !showPallete ? true : undefined, inert: !showPallete ? true : undefined, style: {
                        pointerEvents: showPallete ? 'all' : 'none',
                    }, children: _jsx("div", { className: "colorPaletteContainer", 
                        // style={getColorPalettePosition(colorPaletteOpen)}
                        onClick: function (e) { return e.stopPropagation(); }, ref: palleteRef, role: "group", "aria-label": t('text.colorPalette'), onKeyDown: function (e) {
                            if (e.key === 'Escape') {
                                e.stopPropagation();
                                var idx_2 = colorPaletteOpen;
                                setShowPallete(false);
                                setColorPaletteOpen(-1);
                                setTimeout(function () {
                                    var _a;
                                    (_a = colorBtnRefs.current[idx_2]) === null || _a === void 0 ? void 0 : _a.focus();
                                }, 0);
                                return;
                            }
                            // Focus trap: cycle Tab/Shift+Tab within color palette
                            if (e.key === 'Tab' && palleteRef.current) {
                                var focusable = palleteRef.current.querySelectorAll('button:not([tabindex="-1"])');
                                if (focusable.length === 0)
                                    return;
                                var first = focusable[0];
                                var last = focusable[focusable.length - 1];
                                if (e.shiftKey && document.activeElement === first) {
                                    e.preventDefault();
                                    last.focus();
                                }
                                else if (!e.shiftKey && document.activeElement === last) {
                                    e.preventDefault();
                                    first.focus();
                                }
                            }
                        }, style: showPallete ? { opacity: 1, transform: 'translateY(0px)' } : {}, children: colorBtns.map(function (btn, idx) {
                            var _a, _b;
                            return (_jsx(ButtonComponent, { imgSrc: btn.imgSrc, defaultCSS: "colorBtn", 
                                // clickHandler={() => selectColor(btn.color)}
                                clickHandler: function () { return handleColorChange(colorPaletteOpen, idx); }, ariaHidden: !showPallete, tabIndex: showPallete ? 0 : -1, controlActiveFromOutside: true, isActive: colorPaletteOpen !== -1 &&
                                    btn.color === ((_b = (_a = spinnerData.sections) === null || _a === void 0 ? void 0 : _a[colorPaletteOpen]) === null || _b === void 0 ? void 0 : _b.color), clickActive: true, reference: function (el) {
                                    colorButtonRefs.current[idx] = el;
                                }, ariaLabel: "".concat(t('text.changeColorTo'), " ").concat(t(btn.colorName)), title: t(btn.colorName), showToolTip: true, direction: idx === 0 ? 'topRight' : idx === colorBtns.length - 1 ? 'topLeft' : 'top' }, idx));
                        }) }) }), _jsx(FooterActionsButtons, { disableDoneBtn: disableDone, onActionBtnClick: function (type) {
                        if (type === 'done')
                            handleDone();
                        else
                            handleCancel();
                    } }), _jsx("div", { "aria-live": "polite", "aria-atomic": "true", style: {
                        position: 'absolute',
                        width: '1px',
                        height: '1px',
                        padding: 0,
                        margin: '-1px',
                        overflow: 'hidden',
                        clip: 'rect(0, 0, 0, 0)',
                        whiteSpace: 'nowrap',
                        border: 0,
                    }, children: popupAnnounceText })] }) }));
};
export default SpinnerManipulativePopup;
